import { render, staticRenderFns } from "./table33.vue?vue&type=template&id=04f02d92&scoped=true&"
import script from "./table33.vue?vue&type=script&lang=js&"
export * from "./table33.vue?vue&type=script&lang=js&"
import style0 from "./table33.vue?vue&type=style&index=0&id=04f02d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f02d92",
  null
  
)

export default component.exports